import styled from "styled-components";


export const OrderHeadline = styled.h3`
  margin: 20px 0px;
`;

export const EmailFormatError = styled.p`
  color: red;
`;

export const ConservatoryContainer = styled.div`
  display: flex;
  margin-top: 20px;

  @media (max-width: 480px) {
    display: block;
  }

  > div {
    flex: 1;
    position: relative;
  }

  .PartImage {
    width: 50%;

    @media (max-width: 480px) {
      display: none;
    }
  }
`;

export const ConservatoryInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const ConservatoryData = styled.span`
  margin-right: 20px;
`;

export const ModalFooter = styled.div`
  position: sticky;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  background: ${({ theme }) => theme.secondary};
  display: flex;
  padding: 10px;
  justify-content: space-between;
`;

export const MailContainer = styled.div`
  margin-right: 5px;

  .email-input {
    width: 100%;
    margin-top: 10px;

    @media (min-width: 768px) {
      width: 75%;
    }

    @media (min-width: 1200px) {
      width: 50%;
    }
  }

  & [type="checkbox"] {
    display: inline-block;
    transform: scale(1.5);
    margin-right: 15px;
    cursor: pointer;
  }
`;

export const PrintContainer = styled.div`
  @media (min-width: 768px) {
    margin-top: 20px;
    margin-top: 0;
    margin-left: 5px;
  }
`;

export const SummaryHeader = styled.h2`
  margin: 40px 0px 10px 0px;
`;

export const SendMailButton = styled.button`
  color: ${({ theme }) => theme.link};
  border: 1px solid ${({ theme }) => theme.link};
  background: white;
  font-size: 16px;
  width: 100%;

  @media (min-width: 480px) {
    width: 60%;
  }

  @media (min-width: 768px) {
    width: 40%;
  }
`;

export const PrintButton = styled.button`
  display: block;
  width: 100%;
  color: ${({ theme }) => theme.link};
  border: 1px solid ${({ theme }) => theme.link};
  background: white;
  font-size: 16px;
  margin: 10px 0px;
  // Reset font-smoothing due to light background
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;

  @media (min-width: 480px) {
    width: 60%;
  }

  @media (min-width: 768px) {
    width: 40%;
  }
`;

export const TotalPriceLabel = styled.span`
  font-size: 18px;
  margin-right: 20px;

  @media (min-width: 480px) {
    font-size: 22px;
  }
`;

export const UterumImageContainer = styled.div`
  text-align: center;
  width: 100%;
  display: block;
  position: relative;
  height: 240px;

  @media (min-width: 480px) {
    width: 30%;
    height: auto;
  }
`;

export const OrdinaryPrice = styled.span`
  margin: 5px 0px;
  display: block;
  text-decoration: line-through;
  color: ${({ theme }) => theme.grey};
  font-size: 18px;
`;

export const DiscountedPrice = styled.span`
  font-size: 24px;
  color: ${({ theme }) => theme.discount};

  @media (min-width: 480px) {
    font-size: 36px;
  }
`;

export const SaveAndPrintContainer = styled.div`
  display: flex;
  padding: 20px;
  border-top: 1px solid ${({ theme }) => theme.grey};
  border-bottom: 1px solid ${({ theme }) => theme.grey};
  background: #fbfaf9;
  flex-direction: column;

  @media (min-width: 480px) {
    flex-direction: row;
  }
`;

export const OptInText = styled.div`
  margin: 10px 0px;
  font-size: 12px;
  width: 100%;
  display: flex;
`;

export const UterumImage = styled.img`
  position: absolute;
  width: 100%;
  left: 0;
`;

export const DocumentTitle = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0px;
  font-size: 14px;

  svg {
    flex-grow: 0;
    flex-shrink: 0;
  }
`;

export const DocumentTitleText = styled.span`
  margin: 10px;
`;

export const ArticlePriceModal = styled.h4`
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;
`;

export const ModalHeader = styled.h3`
  text-align: center;
  margin-bottom: 20px;
`;

export const SketchContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: white;
  flex-direction: column;
  padding: 10px;
  justify-content: space-between;

  @media (min-width: 480px) {
    flex-direction: row;
  }

  @media print {
    flex-direction: column;
  }
`;
